import { ActivityCodeApi } from '@/api/ActivityCodeApi';

export async function prefetchActivityCodeSilently() {
    ActivityCodeApi.fetchAll()
}